import { render, staticRenderFns } from "./BidderFundingsTableEmpty.vue?vue&type=template&id=45202dd1&scoped=true&"
import script from "./BidderFundingsTableEmpty.vue?vue&type=script&lang=js&"
export * from "./BidderFundingsTableEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45202dd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VForm,VLayout})
